<template>
    <div class="news-block">
        <div class="news-type">
            <img :src="logoUrl"/>
        </div>
        <div class="news-line"></div>
        <div class="news-list" >
            <NewsItem25  v-for="item in newsData.content" :key="item.contentId"  :content="item"/>
        </div>
        <div class="news-pager">
            <Pager  :total="newsData.totalPages" :allPage="newsData.numberOfElements" v-on:change="changePage"></Pager>
        </div>
    </div>
</template>

<script>
import NewsItem25 from "../components/MobileNewsItem50"

import Pager from "../components/Pager"
export default {
    name:'NewsList',
    components:{NewsItem25, Pager},
    data(){
        return {
            newsData :[],
            columnId:'',
            pageNo:1,
            pageSize:9,
            logoUrl:''
        }
    },
    created(){
        this.columnId = this.$route.query.columnId;
        if(!this.$route.query.columnId){
            MessageBox.alert("缺少参数 columnId");
            return;
        }
    },
    mounted(){
        this.getColumn();
        this.getNews();
    },
    methods:{
        getNews(){
            const self = this;
            this.$http.get("/bicycle/inter/newsList?pageNo="+this.pageNo+"&pageSize="+this.pageSize+"&columnId=" + this.columnId).then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.newsData = res.data.data;
                }
            
            }).catch(function(error){
                console.log(error);
            });
        },
        getColumn(){
            const self = this;
            this.$http.get("/bicycle/inter/columnInfo?columnId=" + this.columnId).then(function(res){
                if(res.data.status != 200){
                    MessageBox.alert(res.data.errorMsg);
                }else{
                    self.logoUrl = res.data.data.imageUrl;
                }
            
            }).catch(function(error){
                console.log(error);
            });
        },
        changePage(page){
            this.pageNo = page;
            this.getNews();
        }
    }
}
</script>

<style scoped>
.news-block{
    width: 100%;
    margin: 0 auto;
    margin-top: 24px;
    margin-bottom: 24px;
}
.news-type{
    text-align: center;
    margin-top: 24px;
}
.news-type img{
    height: 30px;
}
.news-line{
    margin-top: 18px;
    margin-bottom: 18px;
    width: 80%;
    margin-left: auto;
    margin-right: auto;
    border-top: 2px dashed #2E3855;
}
.news-list{
    justify-content: flex-start;
    display: flex;
    align-items: baseline;
    flex-flow: row wrap;
}
.news-pager{
    text-align: right;
    margin-top: 12px;
}
</style>


// WEBPACK FOOTER //
// src/pages/MobileNewsList.vue